import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Abouttekuk() {
  return (
    <section className="abouttek_uk p-100" style={{ background: "#F9F9F9" }}>
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>Why Work with TekRevol?</h2>
            <p>
              TekRevol is an expert-led, full-cycle mobile app development
              company in the UK. We build scalable mobile app solutions with
              interactive frontends and secure backends with a keen focus on
              user engagement, business growth, and future readiness.
            </p>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col xs={12} md={6} lg={6} xl={5} xxl={5}>
            <StaticImage
              src="../../../images/location_new/uk-mobile/about_tek_uk.webp"
              alt="Mobile app development company UK"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={713}
              height={827}
            />
          </Col>
          <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
            <h2>High-Performing Mobile Apps for Sustainable Business Growth</h2>
            <p>
              TekRevol's mobile app development services in the UK focus on
              performant and scalable business growth by launching remarkable
              mobile applications. During our 8 years long journey, we've
              collaborated with multinationals, SMBs, and entrepreneurs,
              overcoming app development challenges efficiently.
            </p>
            <p>
              Our UK team, consisting of top app developers, delivers
              high-performing, disruptive mobile applications with exceptional
              skill and experience. Today, TekRevol operates globally, offering
              diverse digital solutions to businesses of all sizes.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Let’s Build Your Chart-Topping App
            </Link>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="about_growth_main">
              <div className="about_growth_item">
                <div className="about_growth_img">
                  <StaticImage
                    src="../../../images/location_new/uk-mobile/stats/app_dev.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={71}
                    height={72}
                  />
                </div>
                <div className="about_growth_content">
                  <h5>200+</h5>
                  <p>
                    Apps
                    <br /> Developed
                  </p>
                </div>
              </div>
              <div className="about_growth_item">
                <div className="about_growth_img">
                  <StaticImage
                    src="../../../images/location_new/uk-mobile/stats/idea.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={71}
                    height={72}
                  />
                </div>
                <div className="about_growth_content">
                  <h5>15+</h5>
                  <p>
                    Industries
                    <br /> Served
                  </p>
                </div>
              </div>
              <div className="about_growth_item">
                <div className="about_growth_img">
                  <StaticImage
                    src="../../../images/location_new/uk-mobile/stats/review.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={71}
                    height={72}
                  />
                </div>
                <div className="about_growth_content">
                  <h5>4.8</h5>
                  <p>
                    Rating on
                    <br /> Clutch
                  </p>
                </div>
              </div>
              <div className="about_growth_item">
                <div className="about_growth_img">
                  <StaticImage
                    src="../../../images/location_new/uk-mobile/stats/team.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={71}
                    height={72}
                  />
                </div>
                <div className="about_growth_content">
                  <h5>80+</h5>
                  <p>
                    App Development
                    <br /> Experts
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Abouttekuk;
